import { render, staticRenderFns } from "./i-svg.vue?vue&type=template&id=2b5059c4&scoped=true&"
import script from "./i-svg.vue?vue&type=script&lang=js&"
export * from "./i-svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5059c4",
  null
  
)

export default component.exports